<template>
  <div class="search-setting">
    <el-tabs>
      <el-tab-pane label="热搜词设置">
        <el-form ref="form" label-width="80px" @submit.native.prevent>
          <el-form-item label="热搜词">
            <el-tag
              class="tag"
              :key="tag"
              v-for="tag in dynamicTags"
              closable
              :disable-transitions="false"
              @close="handleClose(tag)">
              {{tag}}
            </el-tag>
            <el-input
              class="input-new-tag"
              v-if="inputVisible"
              v-model="inputValue"
              ref="saveTagInput"
              size="small"
              @keyup.enter.native="handleInputConfirm"
              @blur="handleInputConfirm"
            >
            </el-input>
            <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 添加</el-button>
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary" size="small" @click="save"> 保 存 </el-button>
            </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import request from '@/utils/request'
export default {
  name: 'searchSetting',
  data () {
    return {
      dynamicTags: [],
      inputVisible: false,
      inputValue: ''
    }
  },
  created () {
    request({
      url: '/ui/movie/search-keys',
      method: 'get'
    }).then(res => {
      this.dynamicTags = res.data.keys
    })
  },
  methods: {
    handleClose (tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1)
    },

    showInput () {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },

    handleInputConfirm () {
      let inputValue = this.inputValue
      if (inputValue) {
        this.dynamicTags.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },

    save () {
      request({
        url: '/ui/movie/search-keys',
        method: 'patch',
        data: {
          keys: this.dynamicTags
        }
      }).then(res => {
        this.$message.success('保存成功!')
      })
    }
  }
}
</script>
<style lang="less" scoped>
.tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/searchSetting.vue